define('common/utils/mediator',['EventEmitter'], function (EventEmitter) {
    return new EventEmitter();
});

